export const userAppealsListTableConfig = () => {
    return [
        {
            id: "name",
            header: "Пользователь",
            field: "name",
        },
        {
            id: "phone",
            header: "Номер телефона",
            field: "phone",
            sortBy: "basic",
        },
        {
            id: "email",
            header: "E-mail",
            field: "email",
        },
        {
            id: "Тип обращения",
            header: "type",
            field: "type",
        },
        {
            id: "text",
            header: "Обращение",
            field: "text",
        },
        {
            id: "date",
            header: "Дата и время",
            field: "date",
        },
        {
            id: "status",
            header: "Статус",
            field: "Статус",
        },
    ];
}
